import { render } from "./MobileDrawer.vue?vue&type=template&id=6b85800a"
import script from "./MobileDrawer.vue?vue&type=script&lang=js"
export * from "./MobileDrawer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__